/**
 * Work-experience bullets, verbatim from the CV's WORK EXPERIENCE section —
 * same wording, same order, same trailing punctuation.
 *
 * One deviation, deliberate and flagged: the second bullet under the current role
 * reads "see Key Projects below for details and live links" in the CV. That is a
 * cross-reference to a later part of a two-page document. On this site the work
 * grid sits *above* Experience, so "below" would send the reader the wrong way.
 * The destinations are named directly instead, which is what the CV clause points
 * at anyway.
 */
export type Position = {
  id: string;
  location: string;
  achievements: string[];
  technologies: string[];
};

export const positions: Position[] = [
  {
    id: 'currentIndependent',
    location: 'Remote',
    achievements: [
      'Designing and building a multi-vertical booking platform (Places, Clinics, Farms) covering reservation logic, cash deposit flows, and calendar availability.',
      'Delivered Rezma, a clinics/medical center management system, and a web admin dashboard — live on Google Play and resoo-app.com.',
    ],
    technologies: ['Flutter', '.NET', 'REST APIs', 'Booking Platform', 'Reservations'],
  },
  {
    id: 'techgo',
    location: 'Remote',
    achievements: [
      'Architected and shipped multiple Flutter + BLoC mobile apps with strict unidirectional data flow for reliable, scalable state management.',
      'Optimised app startup time and frame rendering, achieving consistently smooth 60fps performance across Android and iOS.',
      'Integrated 5+ third-party REST APIs and services to accelerate feature delivery.',
      'Maintained clean, testable codebases with high code-review participation in an agile team.',
    ],
    technologies: ['Flutter', 'BLoC', 'REST APIs', '60fps', 'Agile'],
  },
  {
    id: 'independent',
    location: 'Remote',
    achievements: [
      'Delivered end-to-end Flutter apps for international clients across fintech, travel, and hospitality, including Wjhtak (live on Google Play).',
      'Implemented secure payment flows with Stripe, PayPal, and MyFatoora.',
      'Built real-time backend features with Supabase, ensuring low-latency data sync across mobile clients.',
    ],
    technologies: ['Flutter', 'Stripe', 'PayPal', 'MyFatoora', 'Supabase'],
  },
  {
    id: 'hitech',
    location: 'Remote',
    achievements: [
      'Built and maintained cross-platform Flutter apps using Provider for state management.',
      'Partnered with UI/UX designers to translate mockups into pixel-perfect interfaces.',
      'Improved app stability through systematic debugging and targeted performance optimisation.',
    ],
    technologies: ['Flutter', 'Provider', 'UI/UX', 'Debugging', 'Optimisation'],
  },
];
